// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Export(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Export" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.5 13.4963H10.3331L7.09266 16.9227L9.11086 19.0254L15.714 12.0443L9.03269 4.98411L7.01876 7.0868L10.2578 10.5117H1.5L1.5 13.4963Z", fill: "currentColor" }),
            React.createElement("path", { d: "M13.5 1.5H22.5V22.5H13.5V19.5H19.5V4.5H13.5V1.5Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Export.js.map